import { yupResolver } from "@hookform/resolvers/yup";
import { ChevronLeftIcon, EnterIcon } from "@radix-ui/react-icons";
import { Button, Card, Flex, Spinner } from "@radix-ui/themes";
import { useForm, Controller } from "react-hook-form";
import toast from "react-hot-toast";
import { useMutation } from "react-query";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import { SubEntityType } from "../../../types/ScientificModule";
import { routes } from "../../../routes";
import { RootState } from "../../../redux/store";
import SelectComponent from "../../../components/inputs/Select/SelectComponent";
import { useGetEntitiesQuery } from '../../../hooks/scientific/useGetEntitiesQuery';
import { updateSubEntity } from "../../../services/scientific/subEntity";
import { CreateSubEntityFormValidation } from "./CreateSubEntityValidationForm";
import { resetSubEntitiesData } from "../../../redux/slices/scientific/subEntities";
import TextFieldComponent from "../../../components/inputs/Textfield/TextfieldComponent";

export const UpdateSubEntity = () => {
  const navigate = useNavigate();
  const dispatch = useDispatch();

  const subEntityData = useSelector((state: RootState) => state.subEntities);
  const { data: entities, isLoading:isLoadingEntities, isError:isErrorEntities, refetch:refreshEntities } = useGetEntitiesQuery({ PageNumber: 1, PageSize: 400});
  
  const mutation = useMutation({ mutationFn: updateSubEntity, mutationKey: "updateSubEntity" });

  const { control, handleSubmit, formState: { errors } } = useForm<SubEntityType>({
    resolver: yupResolver(CreateSubEntityFormValidation),
    defaultValues: subEntityData,
    mode: "onBlur",
    reValidateMode: "onBlur",
    shouldUseNativeValidation: false,
  });

  const onSubmit = handleSubmit(async (data) => {
    try {
      const result = await mutation.mutateAsync(data);
      if (result) {
        toast.success("SubEntidade atualizada com sucesso!");
        handleBack();
      }
    } catch (err: any) {
      toast.error(`${mutation.error ?? err?.message}`);
    }
  });

  const handleBack = () => {
    dispatch(resetSubEntitiesData());
    navigate(routes.subEntities);
  };

  return (
    <form onSubmit={onSubmit} noValidate>
      <Card size="1">
        <Flex direction="column" gap="4">
          <TextFieldComponent name="description" label="Descrição" control={control} errors={errors} fieldProps={{ placeholder: "Descrição" }} required={true}/>
          <SelectComponent
                name="idEntity"
                label="Entidade (Sigla)"
                control={control}
                errors={errors}
                options={entities?.items.map((entity) => ({
                  value: entity.id ?? "",
                  label: entity.description ?? "",
                }))}
                style={{width:'100%'}} 
                itemsLoading={isLoadingEntities}
                itemsError={isErrorEntities}
                required={true}
              />
          <Flex direction="row" gap="3" justify="end">
            <Button type="button" variant="soft" color="gray" onClick={handleBack} disabled={mutation.isLoading}>
              <ChevronLeftIcon /> Voltar
            </Button>
            <Button type="submit" disabled={mutation.isLoading}>
              {mutation.isLoading ? <Spinner /> : <EnterIcon />}
              Atualizar
            </Button>
          </Flex>
        </Flex>
      </Card>
    </form>
  );
};
